import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSwitch = styled(Switch)(
  ({ theme: { palette, colors }, color }) => ({
    '&.toggleSwitch .MuiSwitch-thumb': {
      backgroundColor: colors.iconGrey,
    },
    '&.toggleSwitch .Mui-checked .MuiSwitch-thumb': {
      backgroundColor:
        color === 'secondary' ? palette.secondary.main : palette.primary.main,
    },
    '&.toggleSwitch .MuiSwitch-track': {
      backgroundColor: palette.action.disabledBackground,
      height: '1.6rem',
      width: '3.6rem',
    },
    '&.toggleSwitch .Mui-checked+.MuiSwitch-track': {
      backgroundColor: color === 'secondary' ? '#EBEFF6' : colors.chipsDefault,
    },
  })
);
